import { PropsWithChildren, ReactElement } from "react";
import environmentConfig from "../../../environmentConfig";
import BlenderLoginHandler from "./AuthProvider.BlenderLoginHandler";
import PopupAuthHandler from "./AuthProvider.PopupHandler";
import RedirectAuthHandler from "./AuthProvider.RedirectHandler";
import UserManagerProvider from "./UserManagerContext.Provider";

const { isInIframe, isPopupWindow } = environmentConfig;

export type AuthState = "notAuthenticated" | "inProgress" | "authenticated" | "failed";
export const preferredLoginTenantKey = "aui-preferredLoginTenant";

export const loggedOutPath = "/logged-out.html";
export const crmLoggedOutPath = "/crm/logged-out.html";

/**
 * Handles all authentication related functionality. Until the user is authenticated it will **not** render the children but a loading/error screen.
 *
 * **Provider dependencies:**
 * - (Store) Provider
 * - ThemeProviders
 * - TranslationProvider
 */
export default function AuthProvider({ children }: PropsWithChildren): ReactElement {
  const content = (
    <BlenderLoginHandler>
      {children}
    </BlenderLoginHandler>
  );

  return (
    <UserManagerProvider>
      {
        (isInIframe || isPopupWindow)
          ? <PopupAuthHandler>
              {content}
            </PopupAuthHandler>
          : <RedirectAuthHandler>
              {content}
            </RedirectAuthHandler>
      }
    </UserManagerProvider>
  );
}
